import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { HBox, VBox } from '../../../../../components/Box';
import { selectInvoice } from '../../../../Invoices/selectors';
import { getPropByName } from '../../../../../utils/props';
import { selectAddressTypes } from '../../../../Address/selectors';
import { formatCurrency } from '../../../../../utils/string';
import { VEHICLE_TAX_TYPE } from '../.././../constants';
import * as converter from 'number-to-words';
import { SaleAgreementFooter } from '../SaleAgreementFooter';
import { selectWork } from '../../../../Api/selectors';
import { REQUEST_COMPANY } from '../../../../Companies/constants';
import env, { clientId } from "../../../../../env";
import { AppClientId } from "../../../../Shared/constants";
import { BankAccount } from '../../../../../components/Icon';




const Container = styled.div`
  height: 100%;
  font-family: 'Open sans', sans-serif;

  line-height: 1.2;
  font-size: 19px;
  padding: 25px 30px 0px 30px;
  position: relative;

  .section {
    margin-bottom: 6px;
  }

  .subtitle {
    font-size: 24px;
  }

  width: 100%;
  max-width: 1240px;
  background-color: white;
  color: black;

  .title {
    margin-bottom: 24px;
    fontsize: 450px;
    text-decoration: underline;
  }
`;

const MainList = styled.ol`
  margin: 0 0 20px 0;
  font-weight: 600;

  h2 {
    font-size: 18px;
  }

  .subtitle {
    font-size: 14px;
    font-weight: 400;
  }
`;

const SecondaryList = styled.ol`
  margin: 0 0 20px 0;
  font-weight: 400;
`;

const DataString = styled.span`
  font-weight: 600;
  color: ${props => (props.red ? 'red' : 'black')};
`;

const Header = styled.div`
  width: 100%;
  margin-bottom: 36px;
  padding: 6px 24px;
  background-color: #44546a;
  color: #fff;
`;

const Body = styled.div`
  padding: 0px 45px;
`;

const Footer = styled(HBox)`
width: 95%;
font-size: 13px;
position: absolute;
bottom: ${props => `${props.bottom}px`};
left: 0;
right:0;
padding 0 30px;
justif-content: center;
align-items: center;
`;

const DocField = styled(HBox)`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '3px')};
  height: ${props => (props.height ? props.height : '24px')};

  .label {
    height: 100%;
    padding-left: 6px;
    width: ${props => (props.labelOnly ? '100%' : props.large ? '220px' : props.wideLabel ? '70%' : '50%')};
    background-color: ${props => (props.lightgrey ? '#b8b9be' : '#c2c8e2')};
    font-weight: ${props => !props.strongValue && '600'};
  }
  .value {
    width: ${props => (props.withoutLabelField ? '100%' : props.mediumValueWide ? '60%' : props.large ? '80%' : '50%')};
    font-weight: ${props => props.strongValue && '600'};
    height: 100%;
    padding-left: 10px;
    background-color: #f4f7fe;
  }
`;

const SignatureTable = styled(VBox)`
  width: ${props => (props.width ? props.width : '100%')};
  .table-header {
    text-align: center;
    background-color: #b8b9be;
    border: 1px solid #fff;
  }

  .table-box {
    height: 50px;
    .labelCell {
      background-color: #b8b9be;
      width: 30%;
      height: 100%;
      border: 1px solid #fff;
      padding-left: 8px;
    }
    .valueCell {
      background-color: #f4f7fe;
      width: 70%;
      height: 100%;
      border: 1px solid #fff;
      padding-left: 8px;
    }
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class ExportSaleAgreementComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get outgoingCompany() {
    return this.props.invoice?.outgoingCompany;
  }

  get homeAddress() {
    const homeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;

    const homeAddress = this.outgoingCompany?.addresses.find(address => address?.type?.id == homeId);

    return homeAddress;
  }

  get company() {
    return this.props.company;
  }

  get address() {
    return this.props.address;
  }

  get financialContact() {
    const financialContactId = this.getCompanyPropValue('relation_financial_contact_id');
    const user = this.company?.users?.find(u => u.id == financialContactId);
    return user;
  }

  get companyLabel() {
    let label = `${this.getCompanyPropValue('name') ?? ''}`;

    return this.address?.company_name || label;
  }

  get textByTaxType() {
    let text =
      this.props.vehicle?.tax_type === VEHICLE_TAX_TYPE.BTW
        ? 'De levering betreft een intracommunautaire levering conform artikel 139, lid 1, Richtlijn 2006/112. De Verkoper moet de intracommunautaire levering opnemen in zijn BTW-aangifte per afnemer bij de opgaaf ICL. De Koper verklaart door ondertekening van deze overeenkomst dat de intracommunautaire verwerving wordt opgenomen in zijn BTW-aangifte;'
        : 'De levering betreft een levering onder de bijzondere regeling – gebruikte goederen conform de artikelen 28b tot en met 28i Wet op de omzetbelasting 1968 en hoofdstuk 4 van Titel XII van de EU BTW-richtlijn;';
    return text;
  }

  getCompanyPropValue(name) {
    return getPropByName(this.company, name);
  }

  formatString(str) {
    return <strong color="red">{str ?? ''}</strong>;
  }

  translateTypeToEnglish(type) {
    const translations = {
      brand_name: 'Brand Name',
      model_info: 'Model Information',
      vin: 'VIN',
      date_first_allowance: 'Date',
      model_name: 'Model Name',
      fuel_type: 'Fuel Type',
      regplate: 'Registration Plate',
      mileage: 'Mileage',
    };

  
    return translations[type] || type;
  }

  translateTypeToDutch(type) {
    const translations = {
      brand_name: 'Merknaam',
      model_info: 'Modelinformatie',
      vin: 'VIN',
      date_first_allowance: 'Datum',
      model_name: 'Modelnaam',
      fuel_type: 'Brandstoftype',
      regplate: 'Kenteken',
      mileage: 'Kilometerstand',
    };
  
    return translations[type] || type;
  }
  
  translateTypeToPolish(type) {
    const translations = {
      brand_name: 'Nazwa marki',
      model_info: 'Informacje o modelu',
      vin: 'VIN',
      date_first_allowance: 'Data ',
      model_name: 'Nazwa modelu',
      fuel_type: 'Rodzaj paliwa',
      regplate: 'Tablica rejestracyjna',
      mileage: 'Przebieg',
    };
  
    return translations[type] || type;
  }
  
  translateTypeToGerman(type) {
    const translations = {
      brand_name: 'Markenname',
      model_info: 'Modellinformationen',
      vin: 'VIN',
      date_first_allowance: 'Datum ',
      model_name: 'Modellname',
      fuel_type: 'Kraftstoffart',
      regplate: 'Kennzeichen',
      mileage: 'Kilometerstand',
    };
  
    return translations[type] || type;
  }
  
  
   

  render() {
    if (this.props.language == 'nl') { 
   return this.renderDutch();
    }
    if (this.props.language == 'en') { 
    return this.renderEnglish();
    }
    if (this.props.language == 'pl') {
    return this.renderPolish();
    }
    if (this.props.language == 'de') { 
    return this.renderGerman();
    }
  };


  renderGerman() {
    // if (this.props.companyWork) return <Loader small />;
    const vehicle = this.props.vehicle;
    const invoice = this.props.invoice;
    console.log({ company: this.company, address: this.address }, 'COMPANY');
    return (
      <Container>
        <Body>
          <Header>

          <HBox center vCenter>
  <h1>KAUFVEREINBARUNG</h1>
</HBox>
</Header>
<MainList type="I">
  <li>
    <h2>DIE UNTERZEICHNETEN</h2>
    <SecondaryList>
      <li>
        <DataString red>{this.getCompanyPropValue('name')}</DataString> mit Sitz in <DataString red>{this.address?.city}</DataString> unter der Adresse{' '}
        <DataString red>{this.address?.addressLine1}</DataString> mit der Umsatzsteuer-Identifikationsnummer{' '}
        <DataString red>{this.getCompanyPropValue('BTW_number')}</DataString> rechtsgültig vertreten durch{' '}
        <DataString red>{`${getPropByName(this.financialContact, 'name') ?? ''} ${getPropByName(
          this.financialContact,
          'surname',
        ) ?? ''}`}</DataString>{' '}
        im Folgenden als <DataString>"Käufer"</DataString> bezeichnet;
      </li>
      <li>
      In de Wal Auto’s B.V., eine Gesellschaft mit beschränkter Haftung mit statutarischem Sitz in Lemelerveld und Geschäftsadresse in Zwolle, Kleefstraat 8, mit der Umsatzsteuer-Identifikationsnummer NL800235903B01, eingetragen im Handelsregister der Handelskammer unter der Nummer 05049414, hierin rechtsgültig vertreten durch Herrn H.M.M. in de Wal, nachstehend als: <DataString>Verkäufer</DataString>; die Parteien 1 und 2 werden nachfolgend gemeinsam als <DataString>"Parteien"</DataString> und jeweils einzeln als <DataString>"Partei"</DataString> bezeichnet
      </li>
    </SecondaryList>
    <SecondaryList type="A">
      <li>
        Verkäufer ist Eigentümer des Fahrzeugs <DataString red>{vehicle.brand_name}</DataString>{' '}
        <DataString red>{vehicle.model_name}</DataString> mit der Fahrgestellnummer{' '}
        <DataString red>{vehicle.vin}</DataString> nachstehend als: das <DataString>“Fahrzeug”</DataString>;
      </li>
      <li>
        Die Parteien haben eine Einigung über den Kauf, Verkauf und die Übergabe des Fahrzeugs erzielt, welche
        Einigung die Parteien unter den in dieser Vereinbarung festgelegten Bedingungen näher ausarbeiten möchten, nachfolgend: die <DataString>“Vereinbarung”</DataString>;
      </li>
      <li>
        Verkäufer schließt nach bestem Wissen und Gewissen die Vereinbarung mit dem Käufer ab, wobei der Käufer anerkennt, dass
        der Verkäufer keine Kenntnis von versteckten technischen, tatsächlichen und/oder rechtlichen Status des Fahrzeugs hat und
        der Käufer bestätigt, dass er den Verkäufer nicht aus welchem Grund auch immer im Zusammenhang mit der
        Vereinbarung haftbar machen wird;
      </li>
    </SecondaryList>
  </li>
  <li>
    <h2>KAUF UND VERKAUF</h2>
    <SecondaryList type="I">
      <li>
        <span>Der Käufer kauft vom Verkäufer, wie der Verkäufer dem Käufer das Fahrzeug verkauft:</span>
        <HBox>
                    <VBox>
                     

                        {['brand_name', 'model_info', 'vin', 'date_first_allowance'].map(type => {
                          const translatedType = this.translateTypeToGerman(type);
                          return (
                            <DocField key={type} large strongValue>
                              <div className={`label ${translatedType.toLowerCase()}`}>
                                {this.lbl('vehicle.export.' + translatedType)}
                              </div>
                              <div className="value">
                                <DataString red>{vehicle[type] ?? ''}</DataString>
                              </div>
                            </DocField>
                          );
                        })}
                    </VBox>
                    <VBox>
                    {['model_name', 'fuel_type', 'regplate', 'mileage'].map(type => {
                        const translatedType = this.translateTypeToEnglish(type);
                        return (
                          <DocField key={type} large strongValue>
                            <div className={`label ${translatedType.toLowerCase()}`}>
                              {this.lbl('vehicle.export.' + translatedType)}
                            </div>
                            <div className="value">
                              <DataString red>{vehicle[type] ?? ''}</DataString>
                            </div>
                          </DocField>
                        );
                      })}
                    </VBox>
                  </HBox>
      </li>
      <li>
        Der Käufer erklärt, mit dem Fahrzeug vertraut zu sein, wie im Inspektionsbericht beschrieben, und erkennt an, dass
        der Verkäufer keine Garantie für die Qualität und/oder den Zustand des Fahrzeugs gibt;
      </li>
      <li>
        Das Fahrzeug wird in dem Zustand verkauft und übertragen, in dem es sich zum Zeitpunkt des Vertragsabschlusses befindet,
        einschließlich aller sichtbaren und unsichtbaren Mängel und ohne dass der Verkäufer zu einer Garantie oder
        Freistellung verpflichtet ist;
      </li>
    </SecondaryList>
  </li>
  <li>
    <h2>KAUFPREIS UND ZAHLUNG</h2>
    <SecondaryList type="I">
      <li>
        Der Kaufpreis beträgt{' '}
        <DataString red>{formatCurrency(vehicle?.outgoing_financial_total_amount)}</DataString> nachfolgend der:{' '}
        <DataString>“Kaufpreis”</DataString>;
      </li>
      <li>
        {this.props.vehicle?.tax_type === VEHICLE_TAX_TYPE.BTW ? (
        'Die Lieferung betrifft eine innergemeinschaftliche Lieferung gemäß Artikel 139, Absatz 1, Richtlinie 2006/112. Der Verkäufer muss die innergemeinschaftliche Lieferung in seiner Umsatzsteuererklärung pro Kunde in der ICL-Meldung erfassen. Der Käufer erklärt durch Unterzeichnung dieses Vertrags, dass die innergemeinschaftliche Erwerbung in seiner Umsatzsteuererklärung erfasst wird;'
        ) : (
            'Die Lieferung betrifft eine Lieferung im Rahmen der Sonderregelung – gebrauchte Güter gemäß den Artikeln 28b bis 28i des Umsatzsteuergesetzes von 1968 und Kapitel 4 von Titel XII der EU-Mehrwertsteuerrichtlinie;'
        )}
      </li>

      <li>
        Die Zahlung muss nach Rechnungsdatum umgehend erfolgen;
        <p>
          Die Zahlung erfolgt ausschließlich per Überweisung spätestens <DataString>zwei</DataString>{' '}
          Tage vor dem Liefertermin auf das Bankkonto des Verkäufers{' '}
          <DataString>NL41RABO0127803025</DataString> auf den Namen von <DataString>In de Wal Auto's B.V.</DataString>.
        </p>
      </li>
    </SecondaryList>
  </li>
  <li>
    <h2>Kaution</h2>
    <SecondaryList type="I">
      <li>
        Der Käufer schuldet dem Verkäufer im Rahmen dieser Vereinbarung einen Betrag als Kaution. Dies dient
        zur Sicherstellung, dass das Fahrzeug dauerhaft in{' '}
        <DataString red>{this.address?.country?.name}</DataString> registriert wird und auf den Namen von{' '}<DataString red>{this.getCompanyPropValue('name')}</DataString>. Achtung, dies ist nicht der Name des Empfängers.
        ;
      </li>
      <li>
      Das Fahrzeug muss innerhalb von 10 Wochen nach Rechnungsdatum dauerhaft zugelassen werden.
      </li>
      <li>
        Der Betrag der fälligen Kaution beträgt{' '}
        <DataString red>{formatCurrency(vehicle?.bpm_guarantee_sum)}</DataString> in Worten:
        <DataString red>{converter.toWords(vehicle?.bpm_guarantee_sum ?? 0)}</DataString> Euro;
      </li>
      <li>
        Für den genannten Betrag erhalten Sie eine Rechnung, die Sie umgehend, jedoch spätestens vor der Lieferung, begleichen müssen;
      </li>
      <li>
        Die Kaution wird in vollem Umfang an den Käufer zurückerstattet, sobald der Verkäufer innerhalb einer Frist von zehn (10) Wochen nach Vertragsdatum im Besitz der dauerhaften Registrierung (Teil 1 und Teil 2) gemäß den in Artikel I und II dieses Vertrages beschriebenen Bedingungen der Borgstellung ist.
Wird diese Bedingung nicht innerhalb der genannten Frist erfüllt, ist der Verkäufer berechtigt, die Kaution ganz oder teilweise einzubehalten.
      </li>
    </SecondaryList>
  </li>
  <li>
    <h2>LIEFERUNG DES FAHRZEUGS</h2>
    <SecondaryList type="I" style={{ marginBottom: '350px' }}>
      <li>
        Die tatsächliche Übergabe und Lieferung des Fahrzeugs erfolgt durch Besitzverschaffung und durch
        Unterzeichnung dieser Vereinbarung;
      </li>
      <li>
        Das Fahrzeug muss spätestens 10 Tage nach Zahlungseingang abgeholt werden. Bevor das Fahrzeug abgeholt werden kann, muss dem Verkäufer
        spätestens 24 Stunden vorher eine vom Käufer unterzeichnete und rechtsgültige Abholbestätigung mit entsprechender Vollmacht vorgelegt werden.
      </li>
      <li> Das Fahrzeug wird von einem anerkannten Transportunternehmen durch In de Wal Auto’s an Sie geliefert. </li>
      <li>Das Fahrzeug darf von einem Transportunternehmen mit einem vollständig ausgefüllten CMR-Dokument abgeholt werden.</li>
      <li>
        Nach Erhalt des CMR-Dokuments inklusive Unterschrift vor der Ankunft werden die Fahrzeugdokumente vom Verkäufer per DHL versichert versandt;
      </li>
      <li>
        Der Verkäufer erklärt, dass das Fahrzeug sein Eigentum ist und frei von Belastungen, Pfandrechten und dergleichen ist;
      </li>
      <li>
        Der Käufer kann die Vereinbarung ohne Einschaltung eines Gerichts auflösen, wenn sich herausstellt, dass das Auto nach dem Kauf
        und vor der Lieferung nicht dem im Inspektionsbericht festgehaltenen Zustand entspricht;
      </li>
    </SecondaryList>
  </li>
</MainList>
<Footer page={1} bottom={1754}>
  <SaleAgreementFooter page={'1-2'} />
</Footer>
</Body>
{/* Seite 2 */}
<Body>
  <Header>
    <HBox center vCenter>
      <h1>KAUFSVEREINBARUNG</h1>
    </HBox>
  </Header>
  <MainList type="I" start={6}>
    <li>
      <h2>SONSTIGE BESTIMMUNGEN </h2>
      <SecondaryList type="I">
        <li>Diese Kaufvereinbarung muss spätestens 2 Tage nach Erhalt vom Käufer unterzeichnet werden;</li>
        <li>
          Der Verkäufer hat das Recht, den Kauf zu stornieren, wenn die in dieser Kaufvereinbarung festgelegten Bedingungen nicht erfüllt werden;
        </li>
        <li>Auf diese Kaufvereinbarung ist niederländisches Recht anwendbar; </li>
        <li>
          Für diese Kaufvereinbarung gelten unsere allgemeinen Lieferbedingungen, die auf www.indewal.nl veröffentlicht sind und auf Anfrage kostenlos zur Verfügung gestellt werden;
        </li>
        <li>
          Für diese Kaufvereinbarung gilt unsere Datenschutzrichtlinie, die auf www.indewal.nl veröffentlicht ist;
        </li>
        <li>
          Alle aus dieser Vereinbarung resultierenden Streitigkeiten werden in erster Instanz vom Landgericht Zwolle behandelt.{' '}
        </li>
      </SecondaryList>
    </li>
    <li>
      <h2>UNTERSCHRIFT</h2>
      <span className="subtitle">So vereinbart und unterzeichnet in zweifacher Ausfertigung: </span>
      <HBox>
        <SignatureTable width={'50%'}>
          <HBox center className="table-header">
            <DataString>Von Verkäufer auszufüllen</DataString>
          </HBox>
          <HBox className="table-box">
            <div className="labelCell">Ort: </div>
            <div className="valueCell">Zwolle</div>
          </HBox>
          <HBox className="table-box">
            <div className="labelCell">Datum:</div>
            <div className="valueCell"></div>
          </HBox>
          <HBox className="table-box">
            <div className="labelCell">Name:</div>
            <div className="valueCell"></div>
          </HBox>

          <HBox className="table-box">
            <div className="labelCell">Unterschrift:</div>
            <div className="valueCell"></div>
          </HBox>
        </SignatureTable>
        <SignatureTable width={'50%'}>
          <HBox center className="table-header">
            <DataString>Von Käufer auszufüllen</DataString>
          </HBox>
          <HBox className="table-box">
            <div className="labelCell">Ort: </div>
            <div className="valueCell"></div>
          </HBox>
          <HBox className="table-box">
            <div className="labelCell">Datum:</div>
            <div className="valueCell"></div>
          </HBox>
          <HBox className="table-box">
            <div className="labelCell">Name:</div>
            <div className="valueCell">
              Im Namen von <DataString red>{this.companyLabel}</DataString>
            </div>
          </HBox>

          <HBox className="table-box">
            <div className="labelCell">Unterschrift:</div>
            <div className="valueCell"></div>
          </HBox>
        </SignatureTable>
      </HBox>
    </li>
  </MainList>
  <Footer page={2} bottom={0}>
    <SaleAgreementFooter page={'2-2'} />
  </Footer>
</Body>
</Container>
);
}









  renderDutch() {
    // if (this.props.companyWork) return <Loader small />;
    const vehicle = this.props.vehicle;
    const invoice = this.props.invoice;
    console.log({ company: this.company, address: this.address }, 'COMPANY');
    return (
      <Container>
        <Body>
          <Header>
            <HBox center vCenter>
              <h1>KOOPOVEREENKOMST</h1>
              
            </HBox>
          </Header>
          <MainList type="I">
            <li>
              <h2>DE ONDERGETEKENDEN</h2>
              <SecondaryList>
                <li>
                  <DataString red>{this.getCompanyPropValue('name')}</DataString>
                  gevestigd te <DataString red>{this.address?.city}</DataString> aan het adres{' '}
                  <DataString red>{this.address?.addressLine1}</DataString> met BTW-nummer{' '}
                  <DataString red>{this.getCompanyPropValue('BTW_number')}</DataString> rechtsgeldig vertegenwoordigd door{' '}
                  <DataString red>{`${getPropByName(this.financialContact, 'name') ?? ''} ${getPropByName(
                    this.financialContact,
                    'surname',
                  ) ?? ''}`}</DataString>{' '}
                  te noemen <DataString>“Koper”</DataString>;
                </li>
                <li>
                In de Wal Auto’s B.V., een besloten vennootschap met beperkte aansprakelijkheid, statutair gevestigd te Lemelerveld en kantoorhoudende te Zwolle aan het adres Kleefstraat 8 met BTW-nummer NL800235903B01 ingeschreven in het Handelsregister van de Kamer van Koophandel onder nummer 05049414, ten deze rechtsgeldig vertegenwoordigd door dhr. H.M.M. in de Wal, hierna te noemen:
                  <DataString>Verkoper”</DataString>; de partijen 1 en 2 hierna gezamenlijk te noemen{' '}
                  <DataString>"Partijen"</DataString> en elk afzonderlijk tevens een <DataString>"Partij"</DataString>{' '}
                </li>
              </SecondaryList>
              <SecondaryList type="A">
                <li>
                  Verkoper is eigenaar van het voertuig <DataString red>{vehicle.brand_name}</DataString>{' '}
                  <DataString red>{vehicle.model_name}</DataString> met het chassisnummer{' '}
                  <DataString red>{vehicle.vin}</DataString> hierna aangeduid als: het <DataString>“Voertuig”</DataString>;
                </li>
                <li>
                  Partijen overeenstemming hebben bereikt over koop, verkoop en overdracht van het voertuig, welke
                  overeenstemming partijen nader wensen uit te werken onder de voorwaarden zoals vastgelegd in deze
                  overeenkomst, hierna: de <DataString>“Overeenkomst”</DataString>;
                </li>
                <li>
                  Verkoper sluit naar beste weten en te goeder trouw de Overeenkomst met Koper, waarbij Koper erkent dat
                  Verkoper niet bekend is met verborgen technische, feitelijke en/of juridische status van het voertuig en
                  Koper bevestigt dat hij Verkoper niet aansprakelijk zal houden uit welke hoofde in verband met de
                  Overeenkomst;
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>KOOP EN VERKOOP</h2>
              <SecondaryList type="I">
                <li>
                  <span>Koper koopt van Verkoper, gelijk Verkoper aan Koper verkoopt het voertuig:</span>
                  <HBox>
                    <VBox>
                     

                        {['brand_name', 'model_info', 'vin', 'date_first_allowance'].map(type => {
                          const translatedType = this.translateTypeToDutch(type);
                          return (
                            <DocField key={type} large strongValue>
                              <div className={`label ${translatedType.toLowerCase()}`}>
                                {this.lbl('vehicle.export.' + translatedType)}
                              </div>
                              <div className="value">
                                <DataString red>{vehicle[type] ?? ''}</DataString>
                              </div>
                            </DocField>
                          );
                        })}
                    </VBox>
                    <VBox>
                    {['model_name', 'fuel_type', 'regplate', 'mileage'].map(type => {
                        const translatedType = this.translateTypeToDutch(type);
                        return (
                          <DocField key={type} large strongValue>
                            <div className={`label ${translatedType.toLowerCase()}`}>
                              {this.lbl('vehicle.export.' + translatedType)}
                            </div>
                            <div className="value">
                              <DataString red>{vehicle[type] ?? ''}</DataString>
                            </div>
                          </DocField>
                        );
                      })}
                    </VBox>
                  </HBox>
                </li>
                <li>
                  Koper verklaart met het voertuig bekend te zijn zoals omschreven in het inspectierapport en erkent dat
                  Verkoper geen enkele garantie geeft voor de kwaliteit en/of status van het voertuig;
                </li>
                <li>
                  Het Voertuig wordt verkocht en overgedragen in de staat waarin het zich ten tijde van de overeenkomst
                  bevindt, inclusief alle zichtbare en onzichtbare gebreken en zonder dat Verkoper tot enige garantie of
                  vrijwaring is gehouden;
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>KOOPSOM EN BETALING</h2>
              <SecondaryList type="I">
                <li>
                  De koopprijs bedraagt{' '}
                  <DataString red>{formatCurrency(vehicle?.outgoing_financial_total_amount)}</DataString> hierna de:{' '}
                  <DataString>“Koopprijs”</DataString>;
                </li>

                <li>{this.props.vehicle?.tax_type === VEHICLE_TAX_TYPE.BTW ? (
                    'De levering betreft een intracommunautaire levering conform artikel 139, lid 1, Richtlijn 2006/112. De Verkoper moet de intracommunautaire levering opnemen in zijn BTW-aangifte per afnemer bij de opgaaf ICL. De Koper verklaart door ondertekening van deze overeenkomst dat de intracommunautaire verwerving wordt opgenomen in zijn BTW-aangifte;'
                  ) : (
                    'De levering betreft een levering onder de bijzondere regeling – gebruikte goederen conform de artikelen 28b tot en met 28i Wet op de omzetbelasting 1968 en hoofdstuk 4 van Titel XII van de EU BTW-richtlijn;'
                  )}
                  </li>      
                <li>
                  De betaling moet na factuurdatum per omgaande voldaan worden;
                  <p>
                    Betaling vindt plaats uitsluitend met een bankoverschrijving uiterlijk <DataString>twee</DataString>{' '}
                    dagen voor het moment van leveren op het bankrekeningnummer van de verkoper{' '}
                    <DataString>NL41RABO0127803025</DataString> ten name van <DataString>In de Wal Auto's B.V.</DataString>.
                  </p>
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>BORGSTELLING</h2>
              <SecondaryList type="I">
                <li>
                  De koper is in het kader van deze overeenkomst een bedrag aan borg verschuldigd jegens de verkoper. Dit ter
                  dekking voor de zekerheid dat het voertuig duurzaam wordt geregistreerd in{' '}
                  <DataString red>{this.address?.city}</DataString> en op naam van{' '} Let op dit is niet de naam van de afnemer. 
                  <DataString red>{getPropByName(this.financialContact, 'name') ?? ''}</DataString>;
                </li>
                <li>
                  Het voertuig  dient binnen 10 weken na factuurdatum duurzaam te worden geregistreerd.. 
                </li>
                <li>
                  Het bedrag aan verschuldigde borg is vastgesteld op{' '}
                  <DataString red>{formatCurrency(vehicle?.bpm_guarantee_sum)}</DataString> zegge ”
                  <DataString red>{converter.toWords(vehicle?.bpm_guarantee_sum ?? 0)}</DataString>” Euro;
                </li>
                <li>
                  Voor het betreffende bedrag ontvangt u een factuur, deze factuur dient u per omgaande te voldoen doch in
                  ieder geval voor het moment van leveren;
                </li>
                <li>
                  Het borg bedrag zal geheel aan de Koper worden teruggestort zodra de Verkoper in het bezit is van de
                  duurzame registratie conform de voorwaarden zoals beschreven in artikel I en II van 'borgstelling'. Is er niet voldaan aan
                  deze voorwaarden, heeft de Verkoper het recht om het borgbedrag te behouden.
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>LEVERING VAN HET VOERTUIG</h2>
              <SecondaryList type="I" style={{ marginBottom: '350px' }}>
                <li>
                  De feitelijke overdracht en levering van het voertuig vindt plaats door bezitsverschaffing en door
                  ondertekening van deze overeenkomst;
                </li>
                <li>
                  Het voertuig moet uiterlijk binnen 10 dagen na betaling worden afgehaald. Alvorens het voertuig kan worden
                  afgehaald dient er een door koper ondertekende en rechtsgeldige afhaalbevestiging met betreffende volmacht
                  minimaal 24 uur vooraf te worden overlegd aan Verkoper
                </li>
                <li>
                 Het voertuig wordt door een erkende transporteur door In de Wal Auto’s aan u geleverd.
                </li>
                <li>Het voertuig mag door een transportbedrijf met een volledig ingevuld CMR-document worden afgehaald.</li>
                <li>
                  Na ontvangst van het CMR-document inclusief handtekening voor aankomst worden de voertuigdocumenten door de
                  Verkoper via DHL aangetekend verstuurd;
                </li>
                <li>
                  De verkoper verklaart dat het voertuig zijn eigendom is en vrij is van lasten, beslagen en dergelijke;
                </li>
                <li>
                  De koper kan de overeenkomst zonder tussenkomst van de rechter ontbinden indien blijkt dat de auto na koop
                  en voor de levering niet overstemt met de staat van het voertuig zoals is vastgelegd in het
                  inspectierapport;
                </li>
              </SecondaryList>
            </li>
          </MainList>
          <Footer page={1} bottom={1754}>
            <SaleAgreementFooter page={'1-2'} />
          </Footer>
        </Body>
        {/* Page 2 */}

        <Body>
          <Header>
            <HBox center vCenter>
              <h1>KOOPOVEREENKOMST</h1>
            </HBox>
          </Header>
          <MainList type="I" start={6}>
            <li>
              <h2>OVERIGE BEPALINGEN </h2>
              <SecondaryList type="I">
                <li>Deze koopovereenkomst dient uiterlijk binnen 2 dagen na ontvangst te zijn ondertekend door koper;</li>
                <li>
                  Verkoper heeft het recht de koop te ontbinden wanneer er niet wordt voldaan aan de voorwaarden zoals deze
                  zijn beschreven in deze koopovereenkomst;
                </li>
                <li>Op deze koopovereenkomst is het Nederlandse recht van toepassing; </li>
                <li>
                  Op deze koopovereenkomst zijn onze algemene leveringsvoorwaarden van toepassing, deze staan op www.indewal.nl gepubliceerd en worden op verzoek kosteloos ter beschikking gesteld;
                </li>
                <li>
                  Op deze koopovereenkomst is onze privacy policy van toepassing, deze staat op www.indewal.nl gepubliceerd;
                </li>
                <li>
                  Alle uit deze overeenkomst voortvloeiende geschillen worden in eerste aanleg behandeld door de rechtbank Zwolle.{' '}
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>ONDERTEKENING</h2>
              <span className="subtitle">Aldus in tweevoud overeengekomen en overtekend: </span>
              <HBox>
                <SignatureTable width={'50%'}>
                  <HBox center className="table-header">
                    <DataString>In te vullen door Verkoper</DataString>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Plaats: </div>
                    <div className="valueCell">Zwolle</div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Datum:</div>
                    <div className="valueCell"></div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Naam:</div>
                    <div className="valueCell"></div>
                  </HBox>

                  <HBox className="table-box">
                    <div className="labelCell">Handtekening:</div>
                    <div className="valueCell"></div>
                  </HBox>
                </SignatureTable>
                <SignatureTable width={'50%'}>
                  <HBox center className="table-header">
                    <DataString>In te vullen door Koper</DataString>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Plaats: </div>
                    <div className="valueCell"></div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Datuum:</div>
                    <div className="valueCell"></div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Naam:</div>
                    <div className="valueCell">
                      Namens <DataString red>{this.companyLabel}</DataString>
                    </div>
                  </HBox>

                  <HBox className="table-box">
                    <div className="labelCell">Handtekening:</div>
                    <div className="valueCell"></div>
                  </HBox>
                </SignatureTable>
              </HBox>
            </li>
          </MainList>
          <Footer page={2} bottom={0}>
            <SaleAgreementFooter page={'2-2'} />
          </Footer>
        </Body>
      </Container>
    );
  }

  renderPolish() {
    // if (this.props.companyWork) return <Loader small />;
    const vehicle = this.props.vehicle;
    const invoice = this.props.invoice;
    console.log({ company: this.company, address: this.address }, 'COMPANY');
    return (
      <Container>
        <Body>
          <Header><HBox center vCenter>
  <h1>Umowa kupna</h1>
</HBox>
</Header>
<MainList type="I">
  <li>
    <h2>NIŻEJ PODPISANI:</h2>
    <SecondaryList>
      <li>
        <DataString red>{this.getCompanyPropValue('name')}</DataString> z siedzibą w{' '}
        <DataString red>{this.address?.city}</DataString>  przy adresie{' '}
        <DataString red>{this.address?.addressLine1}</DataString>  z numerem VAT{' '}
        <DataString red>{this.getCompanyPropValue('BTW_number')}</DataString>, prawnie reprezentowana przez {' '}
        <DataString red>{`${getPropByName(this.financialContact, 'name') ?? ''} ${getPropByName(
          this.financialContact,
          'surname',
        ) ?? ''}`}</DataString>{' '}
        zwana dalej <DataString>"Kupującym"</DataString>;
      </li>
      <li>
        In de Wal Auto's B.V., spółka z ograniczoną odpowiedzialnością, zarejestrowana w Lemelerveld i zlokalizowana
        przy ul. Kleefstraat 8 w Zwolle, z numerem VAT NL800235903B01, zarejestrowana w Kamerze Handlowej pod numerem
        05049414, prawnie reprezentowana przez Pana H.M.M. in de Wal, zwana dalej <DataString>Sprzedającym</DataString>;
        strony 1 i 2 zwane dalej łącznie <DataString>"Stronami"</DataString>, a każda z osobna zwana <DataString>"Stroną"</DataString>{' '}
      </li>
    </SecondaryList>
    <SecondaryList type="A">
      <li>
        Sprzedający jest właścicielem pojazdu <DataString red>{vehicle.brand_name}</DataString>{' '}
        <DataString red>{vehicle.model_name}</DataString> o numerze nadwozia {' '}
        <DataString red>{vehicle.vin}</DataString> zwany dalej: <DataString>Pojazdem</DataString>;
      </li>
      <li>
        Strony osiągnęły porozumienie w sprawie kupna, sprzedaży i przeniesienia Pojazdu, którego warunki Strony chcą
        dalej rozwijać zgodnie z postanowieniami niniejszej umowy, zwanej dalej: <DataString>“Umową”</DataString>;
      </li>
      <li>
        Sprzedający zawiera Umowę z Kupującym zgodnie z najlepszymi wiadomościami i w dobrej wierze, przy czym Kupujący
        potwierdza, że Sprzedający nie jest świadomy żadnych ukrytych stanów technicznych, faktycznych i/lub prawnych
        Pojazdu, a Kupujący potwierdza, że nie będzie dochodził roszczeń wobec Sprzedającego z jakiejkolwiek przyczyny
        związanej z Umową.
      </li>
    </SecondaryList>
  </li>
  <li>
    <h2>ZAKUP I SPRZEDAŻ</h2>
    <SecondaryList type="I">
      <li>
        <span>Kupujący nabywa od Sprzedającego, a Sprzedający sprzedaje Kupującemu, pojazd:</span>
        <HBox>
                    <VBox>
                     

                        {['brand_name', 'model_info', 'vin', 'date_first_allowance'].map(type => {
                          const translatedType = this.translateTypeToPolish(type);
                          return (
                            <DocField key={type} large strongValue>
                              <div className={`label ${translatedType.toLowerCase()}`}>
                                {this.lbl('vehicle.export.' + translatedType)}
                              </div>
                              <div className="value">
                                <DataString red>{vehicle[type] ?? ''}</DataString>
                              </div>
                            </DocField>
                          );
                        })}
                    </VBox>
                    <VBox>
                    {['model_name', 'fuel_type', 'regplate', 'mileage'].map(type => {
                        const translatedType = this.translateTypeToPolish(type);
                        return (
                          <DocField key={type} large strongValue>
                            <div className={`label ${translatedType.toLowerCase()}`}>
                              {this.lbl('vehicle.export.' + translatedType)}
                            </div>
                            <div className="value">
                              <DataString red>{vehicle[type] ?? ''}</DataString>
                            </div>
                          </DocField>
                        );
                      })}
                    </VBox>
                  </HBox>
      </li>
      <li>
        Kupujący oświadcza, że zna pojazd zgodnie z opisem w raporcie z badania i potwierdza, że Sprzedający nie udziela
        żadnej gwarancji co do jakości i/lub stanu technicznego pojazdu;
      </li>
      <li>
        Pojazd jest sprzedawany i przenoszony w stanie, w jakim jest w chwili zawarcia umowy, z wszelkimi widocznymi i
        niewidocznymi wadami, bez jakiejkolwiek gwarancji ani zobowiązań ze strony Sprzedającego.
      </li>
    </SecondaryList>
  </li>
  <li>
    <h2>CENA ZAKUPU I PŁATNOŚĆ</h2>
    <SecondaryList type="I">
      <li>
        Cena zakupu wynosi{' '}
        <DataString red>{formatCurrency(vehicle?.outgoing_financial_total_amount)}</DataString> zwana dalej{' '}
        <DataString>“Ceną Zakupu”</DataString>;
      </li>

      <li>{this.props.vehicle?.tax_type === VEHICLE_TAX_TYPE.BTW ? (
    'Dostawa dotyczy dostawy wewnątrzwspólnotowej zgodnie z artykułem 139, ustęp 1, Dyrektywy 2006/112. Sprzedawca musi uwzględnić dostawę wewnątrzwspólnotową w swoim zeznaniu podatkowym VAT dla każdego nabywcy w deklaracji ICL. Kupujący oświadcza podpisaniem niniejszej umowy, że wewnątrzwspólnotowe nabycie zostanie uwzględnione w jego deklaracji VAT;'
) : (
    'Dostawa dotyczy dostawy w ramach szczególnego reżimu – używane dobra zgodnie z artykułami 28b do 28i Ustawy o podatku od towarów i usług z 1968 roku oraz rozdziałem 4 Tytułu XII Dyrektywy VAT UE;'
)}
</li>
      <li>
        Płatność musi być dokonana natychmiast po dacie wystawienia faktury;
        <p>
          Płatność dokonywana jest wyłącznie przelewem bankowym, nie później niż <DataString>dwa</DataString> dni przed
          czasem dostawy, na numer konta bankowego Sprzedającego.{' '}
          <DataString>NL41RABO0127803025</DataString> na rzecz <DataString>In de Wal auto's BV </DataString>.
        </p>
      </li>
    </SecondaryList>
  </li>
</MainList>
<MainList type="I">
  <li>
    <h2>GWARANCJA</h2>
    <SecondaryList type="I">
      <li>
        W związku z niniejszą umową Kupujący zobowiązuje się do wpłacenia Sprzedającemu kwoty kaucji. Ma to pokryć zapewnienie, że pojazd zostanie trwale zarejestrowany w{' '}
        <DataString red>{this.address?.city}</DataString> i na nazwisko{' '} Uwaga, to nie jest nazwa odbiorcy.
        <DataString red>{getPropByName(this.financialContact, 'name') ?? ''}</DataString>;
      </li>
      <li> Pojazd musi zostać trwale zarejestrowany w ciągu 10 tygodni od daty wystawienia faktury. </li>
      <li>
        Kwota kaucji wynosi{' '}
        <DataString red>{formatCurrency(vehicle?.bpm_guarantee_sum)}</DataString> czyli{' '}
        <DataString red>{converter.toWords(vehicle?.bpm_guarantee_sum ?? 0)}</DataString> Euro;
      </li>
      <li>
        Za tę kwotę otrzymasz fakturę, którą musisz uiścić natychmiast, ale w każdym razie przed czasem dostawy;
      </li>
      <li>
      Kaucja zostanie w całości zwrócona kupującemu, gdy sprzedający otrzyma trwałą rejestrację pojazdu zgodnie z warunkami opisanymi w artykułach I i II dotyczącymi „borgstelling”. W przypadku niespełnienia tych warunków sprzedający ma prawo zatrzymać kaucję.      </li>
    </SecondaryList>
  </li>
  <li>
    <h2>DOSTAWA POJAZDU</h2>
    <SecondaryList type="I" style={{ marginBottom: '350px' }}>
      <li>
        Rzeczywiste przekazanie i dostawa pojazdu odbywają się poprzez przejęcie posiadania i podpisanie niniejszej umowy;
      </li>
      <li>
        Pojazd musi być odebrany nie później niż 10 dni po dokonaniu płatności. Zanim pojazd zostanie odebrany, Kupujący musi dostarczyć Sprzedającemu podpisaną i prawnie ważną potwierdzenie odbioru wraz z odpowiednimi uprawnieniami, co najmniej 24 godziny wcześniej;
      </li>
      <li> Pojazd zostanie dostarczony do Państwa przez firmę In de Wal Auto’s za pośrednictwem autoryzowanego przewoźnika. </li>
      <li>Pojazd może być odebrany przez firmę transportową z w pełni wypełnionym dokumentem CMR.</li>
      <li>
        Po otrzymaniu dokumentu CMR wraz z podpisem po przyjeździe, dokumenty pojazdu zostaną wysłane przez Sprzedającego za pośrednictwem poczty rejestrowanej DHL;
      </li>
      <li>
        Sprzedający oświadcza, że ​​pojazd jest jego własnością i wolny od wszelkich obciążeń i zobowiązań;
      </li>
      <li>
        Kupujący może odstąpić od umowy bez interwencji sądu, jeżeli okaże się, że samochód po zakupie i przed dostawą nie odpowiada stanowi pojazdu, jak to zostało zarejestrowane w raporcie z badania.
      </li>
    </SecondaryList>
  </li>
</MainList>

<Footer page={1} bottom={1754}>
  <SaleAgreementFooter page={'1-2'} />
</Footer>
</Body>
{/* Page 2 */}
<Body>
  <Header>
    <HBox center vCenter>
      <h1>Umowa kupna</h1>
    </HBox>
  </Header>
  <MainList type="I" start={6}>
    <li>
      <h2>INNE POSTANOWIENIA </h2>
      <SecondaryList type="I">
        <li>Ta umowa kupna musi być podpisana przez kupującego nie później niż 2 dni po otrzymaniu;</li>
        <li>
          Sprzedający ma prawo rozwiązać umowę, jeżeli warunki opisane w niniejszej umowie kupna nie zostaną spełnione;
        </li>
        <li>Do tej umowy kupna stosuje się prawo holenderskie;</li>
        <li>
          Do tej umowy kupna stosuje się nasze ogólne warunki, które są opublikowane na stronie www.indewal.nl i są udostępniane bezpłatnie na życzenie;
        </li>
        <li>
          Do tej umowy kupna stosuje się naszą politykę prywatności, opublikowaną na stronie www.indewal.nl;
        </li>
        <li>
          Wszelkie spory wynikające z niniejszej umowy będą początkowo rozpatrywane przez sąd w Zwolle.
        </li>
      </SecondaryList>
    </li>
    <li>
  <h2>PODPIS</h2>
  <span className="subtitle">Zatem uzgodnione i podpisane w dwóch egzemplarzach:</span>
  <HBox>
    <SignatureTable width={'50%'}>
      <HBox center className="table-header">
        <DataString>Do wypełnienia przez Sprzedającego</DataString>
      </HBox>
      <HBox className="table-box">
        <div className="labelCell">Lokalizacja:</div>
        <div className="valueCell">Zwolle</div>
      </HBox>
      <HBox className="table-box">
        <div className="labelCell">Data:</div>
        <div className="valueCell"></div>
      </HBox>
      <HBox className="table-box">
        <div className="labelCell">Imię:</div>
        <div className="valueCell"></div>
      </HBox>
      <HBox className="table-box">
        <div className="labelCell">Podpis:</div>
        <div className="valueCell"></div>
      </HBox>
    </SignatureTable>
    <SignatureTable width={'50%'}>
      <HBox center className="table-header">
        <DataString>Do wypełnienia przez Kupującego</DataString>
      </HBox>
      <HBox className="table-box">
        <div className="labelCell">Lokalizacja:</div>
        <div className="valueCell"></div>
      </HBox>
      <HBox className="table-box">
        <div className="labelCell">Data:</div>
        <div className="valueCell"></div>
      </HBox>
      <HBox className="table-box">
        <div className="labelCell">Imię:</div>
        <div className="valueCell">
          W imieniu <DataString red>{this.companyLabel}</DataString>
        </div>
      </HBox>
      <HBox className="table-box">
        <div className="labelCell">Podpis:</div>
        <div className="valueCell"></div>
      </HBox>
    </SignatureTable>
  </HBox>
</li>
</MainList>
          <Footer page={2} bottom={0}>
            <SaleAgreementFooter page={'2-2'} />
          </Footer>
        </Body>
      </Container>
    );
  }



  renderEnglish() {
    // if (this.props.companyWork) return <Loader small />;
    const vehicle = this.props.vehicle;
    const invoice = this.props.invoice;
    console.log({ company: this.company, address: this.address }, 'COMPANY');
    return (
      <Container>
        <Body>
          <Header>
            <HBox center vCenter>
              <h1>Purchase Agreement</h1>
              
            </HBox>
          </Header>
          <MainList type="I">
            <li>
              <h2>THE UNDERSIGNED:</h2>
              <SecondaryList>
                <li>
                  <DataString red>{this.getCompanyPropValue('name')}</DataString>
                  established at <DataString red>{this.address?.city}</DataString>  at the address {' '}
                  <DataString red>{this.address?.addressLine1}</DataString>  with VAT number{' '}
                  <DataString red>{this.getCompanyPropValue('BTW_number')}</DataString> validly represented by {' '}
                  <DataString red>{`${getPropByName(this.financialContact, 'name') ?? ''} ${getPropByName(
                    this.financialContact,
                    'surname',
                  ) ?? ''}`}</DataString>{' '}
                  hereinafter referred to as  <DataString>"Buyer"</DataString>;
                </li>
                <li>
                In de Wal Auto's B.V., a private company with limited liability, registered in Lemelerveld and located at Kleefstraat 8 in Zwolle with VAT number NL800235903B01, registered with the Chamber of Commerce under number 05049414, validly represented by Mr. H.M.M. in de Wal, hereinafter referred to as
                  <DataString>Seller</DataString>; the parties 1 and 2 hereinafter collectively referred to as {' '}
                  <DataString>"Parties"</DataString> and each separately referred to as a <DataString>"Party"</DataString>{' '}
                </li>
              </SecondaryList>
              <SecondaryList type="A">
                <li>
                Seller is the owner of the vehicle <DataString red>{vehicle.brand_name}</DataString>{' '}
                  <DataString red>{vehicle.model_name}</DataString> with the chassis number {' '}
                  <DataString red>{vehicle.vin}</DataString> hereinafter referred to as: the <DataString>Vehicle</DataString>;
                </li>
                <li>
                The Parties have reached an agreement on the purchase, sale and transfer of the Vehicle, which agreement the Parties wish to further elaborate on under the conditions as set out in this agreement, hereinafter: the <DataString>“Agreement”</DataString>;
                </li>
                <li>
                Seller enters into the Agreement with Buyer to the best of their knowledge and in good faith, whereby Buyer acknowledges that Seller is not aware of any hidden technical, factual and/or legal status of the Vehicle and Buyer confirms that they will not hold Seller liable for any reason in connection with the Agreement.
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>PURCHASE AND SALE</h2>
              <SecondaryList type="I">
                <li>
                  <span>Buyer purchases from Seller, and Seller sells to Buyer, the vehicle:</span>
                  <HBox>
                    <VBox>
                     

                        {['brand_name', 'model_info', 'vin', 'date_first_allowance'].map(type => {
                          const translatedType = this.translateTypeToEnglish(type);
                          return (
                            <DocField key={type} large strongValue>
                              <div className={`label ${translatedType.toLowerCase()}`}>
                                {this.lbl('vehicle.export.' + translatedType)}
                              </div>
                              <div className="value">
                                <DataString red>{vehicle[type] ?? ''}</DataString>
                              </div>
                            </DocField>
                          );
                        })}
                    </VBox>
                    <VBox>
                    {['model_name', 'fuel_type', 'regplate', 'mileage'].map(type => {
                        const translatedType = this.translateTypeToEnglish(type);
                        return (
                          <DocField key={type} large strongValue>
                            <div className={`label ${translatedType.toLowerCase()}`}>
                              {this.lbl('vehicle.export.' + translatedType)}
                            </div>
                            <div className="value">
                              <DataString red>{vehicle[type] ?? ''}</DataString>
                            </div>
                          </DocField>
                        );
                      })}
                    </VBox>
                  </HBox>
                </li>
                <li>
                Buyer declares to be familiar with the vehicle as described in the inspection report and acknowledges that Seller gives no warranty as to the quality and/or status of the vehicle;
                </li>
                <li>
                The Vehicle is sold and transferred in the condition in which it is at the time of the agreement, including all visible and invisible defects, and without Seller being held to any warranty or indemnification.
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>PURCHASE PRICE AND PAYMENT</h2>
              <SecondaryList type="I">
                <li>
                The purchase price is{' '}
                  <DataString red>{formatCurrency(vehicle?.outgoing_financial_total_amount)}</DataString> hereafter referred to as the{' '}
                  <DataString>“Purchase Price”</DataString>;
                </li>

                <li>{this.props.vehicle?.tax_type === VEHICLE_TAX_TYPE.BTW ? (
    'The delivery concerns an intra-community delivery in accordance with Article 139, paragraph 1, Directive 2006/112. The Seller must include the intra-community delivery in their VAT return for each buyer in the ICL report. The Buyer declares by signing this agreement that the intra-community acquisition will be included in their VAT return;'
) : (
    'The delivery concerns a delivery under the special scheme – used goods in accordance with Articles 28b to 28i of the Value Added Tax Act 1968 and Chapter 4 of Title XII of the EU VAT Directive;'
)}
</li>
                <li>
                Payment must be made immediately after the invoice date;
                  <p>
                  Payment is made only by bank transfer, no later than <DataString>two</DataString> days before the time of delivery, to the Seller's bank account number.{' '}
                    <DataString>NL41RABO0127803025</DataString> on behalf of <DataString>In de Wal auto's BV </DataString>.
                  </p>
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>GUARANTEE</h2>
              <SecondaryList type="I">
                <li>
                In connection with this agreement, the Buyer owes the Seller an amount of security deposit. This is to cover the assurance that the vehicle will be permanently registered in {' '}
                  <DataString red>{this.address?.city}</DataString> and under the name of {' '} Attention, this is not the name of the recipient.
                  <DataString red>{getPropByName(this.financialContact, 'name') ?? ''}</DataString>;
                </li>
                <li> The vehicle must be permanently registered within 10 weeks from the invoice date. </li>
                <li>
                The amount of the security deposit is set at{' '}
                  <DataString red>{formatCurrency(vehicle?.bpm_guarantee_sum)}</DataString> being ”
                  <DataString red>{converter.toWords(vehicle?.bpm_guarantee_sum ?? 0)}</DataString>” Euro;
                </li>
                <li>
                For the amount in question, you will receive an invoice, which you must pay immediately, but in any event before the time of delivery;
                </li>
                <li>
                The deposit will be fully refunded to the buyer once the seller is in possession of the permanent registration in accordance with the conditions described in Articles I and II of the “borgstelling”. If these conditions are not met, the seller has the right to retain the deposit.                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>DELIVERY OF THE VEHICLE</h2>
              <SecondaryList type="I" style={{ marginBottom: '350px' }}>
                <li>
                The actual transfer and delivery of the vehicle takes place through possession and by signing this agreement;
                </li>
                <li>
                The vehicle must be collected no later than 10 days after payment. Before the vehicle can be collected, a signed and legally valid collection confirmation with the relevant authorization must be provided to the Seller at least 24 hours in advance by the Buyer;
                </li>

<li> The vehicle will be delivered to you by In de Wal Auto’s through an approved transport company. </li>
                <li>The vehicle may be collected by a transport company with a fully completed CMR document.</li>
                <li>
                Upon receipt of the CMR document including a signature on arrival, the vehicle documents will be sent by the Seller via DHL registered post;
                </li>
                <li>
                The Seller declares that the vehicle is his property and free of any charges, encumbrances, and the like;
                </li>
                <li>
                The Buyer may terminate the agreement without the intervention of a court if it appears that the car, after purchase and before delivery, does not correspond to the condition of the vehicle as recorded in the inspection report.
                </li>
              </SecondaryList>
            </li>
          </MainList>
          <Footer page={1} bottom={1754}>
            <SaleAgreementFooter page={'1-2'} />
          </Footer>
        </Body>
        {/* Page 2 */}

        <Body>
          <Header>
            <HBox center vCenter>
              <h1>Purchase Agreement</h1>
            </HBox>
          </Header>
          <MainList type="I" start={6}>
            <li>
              <h2>OTHER PROVISIONS </h2>
              <SecondaryList type="I">
               
                <li>This purchase agreement must be signed by the buyer no later than 2 days after receipt;</li>
                <li>
                  The seller has the right to terminate the purchase if the conditions as described in this purchase agreement are not met;
                </li>
                <li>Dutch law applies to this purchase agreement;</li>
                <li>
                  Our general terms and conditions apply to this purchase agreement, which are published on www.indewal.nl and are provided free of charge upon request;
                </li>
                <li>
                  Our privacy policy, published on www.indewal.nl, applies to this purchase agreement;
                </li>
                <li>
                  All disputes arising from this agreement will be initially handled by the Zwolle court.
                </li>
              </SecondaryList>
            </li>
            <li>
            <h2>SIGNATURE</h2>
                <span className="subtitle">Thus agreed upon and signed in duplicate:</span>
              <HBox>
                <SignatureTable width={'50%'}>
                  <HBox center className="table-header">
                    <DataString>To be filled in by Seller</DataString>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Location:</div>
                    <div className="valueCell">Zwolle</div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Date:</div>
                    <div className="valueCell"></div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Name:</div>
                    <div className="valueCell"></div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Signature:</div>
                    <div className="valueCell"></div>
                  </HBox>
                </SignatureTable>
                <SignatureTable width={'50%'}>
                  <HBox center className="table-header">
                    <DataString>To be filled in by Buyer</DataString>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Location:</div>
                    <div className="valueCell"></div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Date:</div>
                    <div className="valueCell"></div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Name:</div>
                    <div className="valueCell">
                      On behalf of <DataString red>{this.companyLabel}</DataString>
                    </div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Signature:</div>
                    <div className="valueCell"></div>
                  </HBox>
                </SignatureTable>


              </HBox>
            </li>
          </MainList>
          <Footer page={2} bottom={0}>
            <SaleAgreementFooter page={'2-2'} />
          </Footer>
        </Body>
      </Container>
    );
  }


}






ExportSaleAgreementComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(ownProps.outgoingInvoiceId),
    addressTypes: selectAddressTypes(),
    companyWork: selectWork(REQUEST_COMPANY),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ExportSaleAgreement = compose(withConnect, withRouter)(ExportSaleAgreementComp);
